var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.languages,"label":_vm.label || _vm.$t('Primary Language')},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})
}
var staticRenderFns = []

export { render, staticRenderFns }